import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReimbursementService } from '../reimbursement.service';
import { userDetails } from '../reimbursement.interfaces';
import { Location } from '@angular/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-reimbursement-view-items-list',
  templateUrl: './reimbursement-view-items-list.component.html',
  styleUrls: ['./reimbursement-view-items-list.component.css']
})
export class ReimbursementViewItemsListComponent implements OnInit {
  sub
  id;
  user;
  sum = 0;
  total;
  expensesItems: userDetails;
  date;
  constructor(private reimbur: ReimbursementService, private location: Location, private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
  ) {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
  }
  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.id = params['id'];
      this.getList();
    });
  }

  async getList() {
    this.spinnerService.show();

    this.expensesItems = await this.reimbur.getUserExpensesItems(this.id);
    this.spinnerService.hide();
    this.totalCost();
    if(this.expensesItems && this.expensesItems.items.length){

      this.expensesItems.items.forEach(data => {
        this.date = data.date;
      });
    }
  }

  totalCost() {
    for (let j = 0; j < this.expensesItems.items.length; j++) {
      this.sum += Number(this.expensesItems.items[j].cost);
    }
  }

  trackByFn(index) {
    return index;
  }
  locationBack() {
    this.location.back();
  }
  goToFile(url) {
    window.location.replace(url);
  }

  downloadReport(reimbursementId) {
    this.spinnerService.show();

    this.reimbur.getReportFile(reimbursementId).subscribe((blob: Blob) => {
      this.spinnerService.hide();

      const fileName = "report.pdf";
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      }
      else {
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }, error => {
      this.spinnerService.hide();
    });
  }

}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/reimbursement/reimbursement-view-items-list/reimbursement-view-items-list.component.ts